// extracted by mini-css-extract-plugin
export default {"formBlock":"PromoCodes_formBlock__EbiEu"};